type Key = {
    value: string,
    isDown: boolean,
    isUp: boolean,
    press?: () => void,
    release?: () => void,
    downHandler: (event: KeyboardEvent) => void,
    upHandler: (event: KeyboardEvent) => void,
    unsubscribe?: () => void
}

function Keyboard(value: string): Key {
    const key: Key = {
        value: value,
        isDown: false,
        isUp: true,
        press: undefined,
        release: undefined,
        downHandler: (event: KeyboardEvent) => {
            console.log(event.key);
            if (event.key === key.value) {
                if (key.isUp && key.press) {
                    key.press();
                }
                key.isDown = true;
                key.isUp = false;
                event.preventDefault();
            }
        },
        upHandler: (event) => {
            if (event.key === key.value) {
                if (key.isDown && key.release) {
                    key.release();
                }
                key.isDown = false;
                key.isUp = true;
                event.preventDefault();
            }
        },
        unsubscribe: () => {
            window.removeEventListener("keydown", key.downHandler);
            window.removeEventListener("keyup", key.upHandler);
        }
    };

    //Attach event listeners
    const downListener = key.downHandler.bind(key);
    const upListener = key.upHandler.bind(key);

    window.addEventListener("keydown", downListener, false);
    window.addEventListener("keyup", upListener, false);

    return key;
}

export default Keyboard;
